var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.206mm",
    height: "40.079mm",
    viewBox: "0 0 30.206 40.079",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.035278 0 0 -.035278 0 40.079)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m214.06 763.51 214.06 123.59 214.05-123.59 214.06-123.58v249l-214.06 123.59-214.05 123.58-214.06-123.58-214.06-123.59v-249l214.06 123.58",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.06 509-214.06 123.59v-248.98l428.12-247.17v1.832l214.05-123.6 25.39-14.672v249.02l-25.39 14.656-214.05 123.59v-1.824l-214.06 123.57",
    fill: "#a3cd3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.12 641.71 214.05 123.6 214.06 123.57v-249l-214.06-123.58-214.05-123.59v249",
    fill: "#a3cd3e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaSymbol);
export default __webpack_public_path__ + "static/media/ra-symbol.1c7cea96.svg";
export { ForwardRef as ReactComponent };